document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-mosaic-carousel]').forEach(function (wrapper) {
    var grid = wrapper.querySelector('[data-mosaic-scroll]');
    var prev = wrapper.querySelector('[data-mosaic-prev]');
    var next = wrapper.querySelector('[data-mosaic-next]');
    if (!grid || !prev || !next) return;

    function scrollAmount() {
      var item = grid.querySelector('.mosaic__item');
      return item ? item.getBoundingClientRect().width + 16 : grid.clientWidth * 0.8;
    }

    prev.addEventListener('click', function () {
      grid.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      grid.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });
});
